module.exports = __webpack_public_path__ + "static/media/roaming-hunger-guarantee.7776154c.jpg";